import { render, staticRenderFns } from "./TheAccordion.vue?vue&type=template&id=ff1007ee"
import script from "./TheAccordion.vue?vue&type=script&lang=js"
export * from "./TheAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports